import style from './index.module.scss';

const VacationsComments = ({ commentsData }: { commentsData: string | null | undefined }) => {
  return (
    <div className={style.wrap}>
      {commentsData && (
        <div className={style.message}>
          <div>
            <span className={style.hr}>Hr</span>
          </div>
          <div className={style.chatText}>{commentsData}</div>
        </div>
      )}
    </div>
  );
};

export default VacationsComments;
